import {
  BUYER_BEWARE_CARDS,
  dataByBuyerBewareCard,
} from "@/constants/company/buyer-beware-card"
import { Signal } from "@/constants/signal/signal"
import type { ReviewWithSignalsAndCompanyId } from "@/db/queries/parsed-review"

type DeceptionSignalOutput = {
  label?: string
  deception_type?: string
}

// Count deception reports from verified customers with solar/battery scope
export function getCountByDeceptionType(
  reviews: ReviewWithSignalsAndCompanyId[]
) {
  const countByType: Record<string, number> = {}

  for (const review of reviews) {
    if (review.signals?.[Signal.STATUS]?.label !== "yes") continue
    if (review.signals?.[Signal.SCOPE]?.label !== "yes") continue

    const deceptionSignal = review.signals?.[Signal.DECEPTION] as
      | DeceptionSignalOutput
      | undefined
    if (deceptionSignal?.label !== "yes") continue

    const deceptionType = deceptionSignal.deception_type
    if (deceptionType && deceptionType !== "none") {
      countByType[deceptionType] = (countByType[deceptionType] ?? 0) + 1
    }
  }

  return countByType
}

export function getCardCount(
  countByType: Record<string, number>,
  deceptionTypes: readonly string[]
) {
  return deceptionTypes.reduce((sum, type) => sum + (countByType[type] ?? 0), 0)
}

export function getBuyerBewareSectionTitle(
  countByType: Record<string, number>
) {
  const combinedCount = BUYER_BEWARE_CARDS.reduce(
    (sum, card) =>
      sum +
      getCardCount(countByType, dataByBuyerBewareCard[card].deceptionTypes),
    0
  )

  if (combinedCount === 0) return "Clean Record"
  if (combinedCount <= 5) return "No Red Flags"
  return "Buyer Beware"
}
